import React, { useEffect, useRef } from "react";
import "../HeroSec/Hero.css";
import image from "../../images/ceo2.png";
const Hero = () => {
  const introTextRef = useRef(null);

  useEffect(() => {
    const introTextElement = introTextRef.current;

    if (introTextElement) {
      setTimeout(() => {
        introTextElement.classList.add("appear");
      }, 500);
    }
  }, []);

  return (
    <>
      <section className="main-section" id="Home-Section">
        <div className="intro-text">
          <span className="desc">
            <h3>This is me</h3>
            <h1 className="hero-name">SHAHZAIB IMRAN</h1>
            <h1 className="css-typing"> Full Stack Developer </h1>
            <br />
            <h3 className="hero-abt">
              {" "}
              Enthusiast to craft solid, scalable & responsive Web Application
              with great UX. <br />
            </h3>
          </span>
        </div>
        <div className="hero-image" ref={introTextRef}>
          <img src={image} alt="CEO" />
        </div>
      </section>
    </>
  );
};

export default Hero;
